import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRolesEnum } from '@collections/users/enums';
import { PortalEventsGQL, PortalEventsResponse } from 'app/shared/services/portal-events/graphql/portal-events.gql.service';
import { QueryRef } from 'apollo-angular';
import { Observable } from 'rxjs';
import { IPortalEvent } from '@collections/portal-events/interfaces/portal-events.interface';
import { SoftDeletePortalEventGQL } from 'app/shared/services/portal-events/graphql/portal-event-delete.gql.service';
import { CardEditBarComponent } from '../../../../shared/components/card-edit-bar/card-edit-bar.component';
import { RenderIfDirective } from '../../../../shared/directives/render-if.directive';
import { EventBlockComponent } from '../../../../portal-events/views/event-block/event-block.component';
import { BlockHorizontalComponent } from '../../../../shared/components/block-horizontal/block-horizontal.component';
import { FullHeaderSliderComponent } from '../../../../layout/components/full-header-slider/full-header-slider.component';
import { OrderType } from '@collections/companies/enums';
@Component({
    selector: 'events-header',
    templateUrl: './portal-events-header.component.html',
    styleUrls: ['./portal-events-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FullHeaderSliderComponent, BlockHorizontalComponent, EventBlockComponent, RenderIfDirective, CardEditBarComponent]
})
export class PortalEventsHeaderComponent implements OnInit {

  UserRolesEnum = UserRolesEnum;
  portalEvent$: Observable<IPortalEvent>;
  recentEventsQuery: QueryRef<PortalEventsResponse>;
  isFirstLoad = true;
  nextPortalEvent = [];
  minDate = new Date(-8640000000000000);

  constructor(
    private portalEventsGQL: PortalEventsGQL,
    private softDeletePortalEventGQL: SoftDeletePortalEventGQL,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {

    this.recentEventsQuery = this.portalEventsGQL.watch({
      first: 3,
      orderType: OrderType.firstin,
      fromDate: Date.now(),
      onlyFirst:3
    })
      
 /*    this.portalEventsGQL.watch({
      first: 3,
      fromDate: new Date("01-01-2018")
    }).valueChanges
      .pipe(
        map(result => result.data.portalEvents),
        take(3),
        untilDestroyed(this),
      ).subscribe(v => {
        v.edges.forEach(element => {
          if(this.nextPortalEvent.indexOf(element.node) < 0 && this.nextPortalEvent.length < 3){
            this.nextPortalEvent.push(element.node)
          }
        })
      })  */


  }

  addEvent(): void {
    this.router.navigate(['../', 'events', 'edit', ''], { relativeTo: this.activatedRoute });
  }

  editEvent(event): void {
    this.router.navigate(['../', 'events', 'edit', event._id], { relativeTo: this.activatedRoute });
  }

  softDeletePortalEvent(event): void {
    this.softDeletePortalEventGQL.mutate({
      id: event._id
    })
    .subscribe();
  }
}
